import { vehicleTreeData } from "@/core/apis";
import { vehicleTreeGrid_generateUniqueId } from "@/assets/js/components/XVehicleTreeGrid";

// getter types
export const VEHICLE_TREE_DATA = "vehicleTreeDataFlat";

// action types
export const GET_VEHICLE_TREE_DATA = "getVehicleTreeDataFlat";
export const PURGE_VEHICLE_TREE_DATA = "purgeVehicleTreeDataFlat";

// mutation types
const SET_VEHICLE_TREE_DATA = "setVehicleTreeDataFlat";
const SET_PURGE_VEHICLE_TREE_DATA = "setPurgeVehicleTreeDataFlat";

const state = {
  vehicleTreeData: []
};

const getters = {
  [VEHICLE_TREE_DATA](state) {
    return state.vehicleTreeData;
  }
};

const actions = {
  [GET_VEHICLE_TREE_DATA](context) {
    return new Promise(resolve => {
      vehicleTreeData.getVehiclesTreeData().then(response => {
        context.commit(SET_VEHICLE_TREE_DATA, response.items);
        resolve();
      });
    });
  },
  [PURGE_VEHICLE_TREE_DATA](context) {
    context.commit(SET_PURGE_VEHICLE_TREE_DATA);
  }
};

const mutations = {
  [SET_VEHICLE_TREE_DATA](state, vehicleTreeData) {
    // Add iran
    vehicleTreeData.unshift({
      id: 0,
      name: "ایران",
      gpS_ID: null,
      parentID: null,
      level: 0,
      description: null,
      isActive: true
    });

    // Change parent id from -1 to 0
    vehicleTreeData
      .filter(c => c.level === 1)
      .forEach(vehicle => (vehicle.parentID = 0));

    // **************************************************
    // TODO: We should move these to server side implementation
    vehicleTreeData
      .filter(c => c.parentID === 2147483647)
      .forEach(vehicle => (vehicle.id = 2147483647));

    vehicleTreeData
      .filter(c => c.level === 3 && c.parentID === 0)
      .forEach(vehicle => (vehicle.parentID = 2147483647));

    vehicleTreeData
      .filter(c => c.level !== 3)
      .forEach(vehicle => (vehicle.isActive = true));
    // **************************************************
    const formatted = vehicleTreeData.map(c => ({
      extra: {
        name: c.name,
        gpS_ID: c.gpS_ID,
        parentID: c.parentID,
        descriptions: c.description
      },
      isActive: c.isActive,
      hasChildren: false,
      selected: false,
      id: c.id,
      level: c.level,
      uniqueId: vehicleTreeGrid_generateUniqueId(c.id, c.level),
      parentUniqueId:
        c.id === 0
          ? null
          : vehicleTreeGrid_generateUniqueId(c.parentID, c.level - 1)
    }));

    const formattedWithoutLastLevel = formatted
      .filter(c => c.level < 3)
      // Order by level - desc
      .sort((first, second) => {
        if (first.level === second.level) {
          return 0;
        } else if (first.level > second.level) {
          return -1;
        } else {
          return 1;
        }
      });

    for (let index = 0; index < formattedWithoutLastLevel.length; index++) {
      const element = formattedWithoutLastLevel[index];
      element.hasChildren = formatted.some(
        q => q.parentUniqueId === element.uniqueId
      );

      if (element.level === 2) {
        element.extra.vehicleCount = formatted.filter(
          c => c.parentUniqueId === element.uniqueId
        ).length;
      } else if (element.level === 1) {
        element.extra.vehicleCount = formatted
          .filter(c => c.parentUniqueId === element.uniqueId)
          .reduce((previous, c) => previous + c.extra.vehicleCount, 0);
      }
    }

    state.vehicleTreeData = [...formatted];
  },
  [SET_PURGE_VEHICLE_TREE_DATA](state) {
    state.vehicleTreeData = [];
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
